import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import { SingleSelect } from "react-select-material-ui";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Tip,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import auth from "./Security/Auth";
import {
  callApiGetJson,
  callApiPostJson,
  OnDemandRefreshInterval,
  callApiGetJsonwithEP,
} from "./GlobalSettings";
import Launchdemospinner from "./Launchdemospinner";
import InfoWarning from "./InfoWarning";
/* import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker } from "@material-ui/pickers"; */

class TMEAddSeatsOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAvailableSeatLoader: false,
      eventTMECRSeats: undefined,
      houstonSelectedCount: 0,
      sgpSelectedCount: 0,
      bristolSelectedCount: 0,
      AddSeatSubmitLoader: false,
      selectedHouSeatNames: this.props.isTMECR ? new Array() : null,
      selectedBriSeatNames: this.props.isTMECR ? new Array() : null,
      selectedSgprSeatNames: this.props.isTMECR ? new Array() : null,
    };

    this.loadAvailableSeatsForTMECR =
      this.loadAvailableSeatsForTMECR.bind(this);
    this._handleHoustonSeatCount = this._handleHoustonSeatCount.bind(this);
    this._handleSgpSeatCount = this._handleSgpSeatCount.bind(this);
    this._handleBristolSeatCount = this._handleBristolSeatCount.bind(this);
    this._handleAddSeatsSubmit = this._handleAddSeatsSubmit.bind(this);
  }

  componentDidMount() {
    this.loadAvailableSeatsForTMECR();
  }

  _handleAddSeatsSubmit() {
    let token = auth.getToken();
    var endpoint = "/Events/AddMoreTMESeats";

    // Here to put further execution under customewr name and with eiher nooppid resaon or oppid
    this.setState({ AddSeatSubmitLoader: true });
    var ReqPayload = {
      Event_Id: this.props.Event.Event_ID,
      PhyContID: this.props.Event.PhysicalContents.Phy_ID,
      HoustonSeats: this.state.selectedHouSeatNames,
      SgpSeats: this.state.selectedSgprSeatNames,
      BristolSeats: this.state.selectedBriSeatNames,
      StartTime: this.props.Event.Event_StartDate,
      EndTime: this.props.Event.Event_EndDate,
    };
    //this.setState({ bShowEvtCreationOnDemandLoader: true });

    console.log("TME Add Seats Req Payload is ", ReqPayload);
    console.log("submitted - to endpoint  " + endpoint);
    console.log(
      "TME Add Seats Req Payload Stringyfied is ",
      JSON.stringify(ReqPayload)
    );
    //console.log(JSON.stringify(this.state.newEventRequestVM));
    //todo:  implement update or insert

    callApiPostJson(endpoint, ReqPayload, token).then((data) => {
      console.log("Response: AddTMESeats is");
      //this.setState({ submittingData: false });
      console.log(data);
      if (
        data &&
        data.CRSeatUpdateMsg.includes("SUCCESS")
        //data.CRSeatUpdateMsg.indexOf("FAILED") < 1
      ) {
        this.setState({
          AddSeatSubmitLoader: false,
        });
        // console.log("Updated message is ", data.CRSeatUpdateMsg);
        // console.log("Yo Yo Hippy Hippy Yo Yo Yo");
        this.props.backwithYes();
      } else if (data && data.CRSeatUpdateMsg.includes("FAILED")) {
        this.setState({
          AddSeatSubmitLoader: false,
        });
        //console.log("Who let the Dogs Out Boo Boo Boo!");
        this.props.backwithNo();
      }
    });
  }

  loadAvailableSeatsForTMECR() {
    this.setState({ showAvailableSeatLoader: true });
    //console.log(date);
    var endpoint = "/Events/TMECRAvailableSeats";
    var postData =
      this.props.timeZoneCR && this.props.isTMECR
        ? {
            Day: this.props.Event.Event_StartDate,
            Duration: this.props.Event.Event_Duration.Duration_ID,
            PhysicalContentID: this.props.Event.PhysicalContents.Phy_ID,
            evtTimezone: this.props.Event.EventTimeZone,
          }
        : {
            Day: this.props.Event.Event_StartDate,
            Duration: this.props.Event.Event_Duration.Duration_ID,
            PhysicalContentID: this.props.Event.PhysicalContents.Phy_ID,
            evtTimezone: null,
          };
    let token = auth.getToken();

    console.log("Before TmeCRSeats Call req Payload is ", postData);
    callApiPostJson(endpoint, postData, token).then((data) => {
      console.log("TME_CR_AvailableSeats data:" + data);
      if (data !== undefined) {
        this.setState({
          eventTMECRSeats: data,
          showAvailableSeatLoader: false,
        });
      }
    });

    //this just refreshes the user token if necessary
    // auth.verifyToken(true);
  }

  _handleHoustonSeatCount(event) {
    console.log("HoustonSeat Selected Count ", event.value);
    /* var TotalHouston = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("houston") > 0) {
        TotalHouston = tmest.DCAvailableSeatCount;
      }
    });
    console.log("Total Houston Seats are ", TotalHouston);
    // console.log("Is Value contain dot ", String(value).indexOf(".") <= 0);
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalHouston) {
        console.log("Yeah its true hence TTTTT");
        this.setState({ houstonSelectedCount: value });
      } else {
        console.log("Yeah its false hence FFFFF");
        this.setState({ houstonSelectedCount: TotalHouston });
      }
    } else {
      this.setState({ houstonSelectedCount: 0 });
    } */
    this.setState({ selectedHouSeatNames: event.value });
  }

  _handleSgpSeatCount(event) {
    console.log("Singapore Seat Selected Count ", event.value);
    /*     var TotalSgp = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("singapore") > 0) {
        TotalSgp = tmest.DCAvailableSeatCount;
      }
    });
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalSgp) {
        this.setState({ sgpSelectedCount: value });
      } else {
        this.setState({ sgpSelectedCount: TotalSgp });
      }
    } else {
      this.setState({ sgpSelectedCount: 0 });
    } */
    this.setState({ selectedSgprSeatNames: event.value });
  }

  _handleBristolSeatCount(event) {
    console.log("Bristol Seat Selected Count ", event.value);
    /* var TotalBristol = 0;
    this.state.eventTMECRSeats.map((tmest) => {
      if (tmest.DataCenterName.toLowerCase().indexOf("bristol") > 0) {
        TotalBristol = tmest.DCAvailableSeatCount;
      }
    });
    if (String(value).indexOf(".") <= 0) {
      if (value <= TotalBristol) {
        this.setState({ bristolSelectedCount: value });
      } else {
        this.setState({ bristolSelectedCount: TotalBristol });
      }
    } else {
      this.setState({ bristolSelectedCount: 0 });
    } */
    this.setState({ selectedBriSeatNames: event.value });
  }

  render() {
    console.log("From Parent Event is ", this.props.Event);
    console.log("From Parent is Event TME Classroom", this.props.isTMECR);

    var chakracontent = "";
    var ghorChakracontent = "";

    var tobeDisabled = this.state.showAvailableSeatLoader
      ? this.state.showAvailableSeatLoader
      : false;

    if (this.state.AddSeatSubmitLoader) {
      ghorChakracontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner
              size="small"
              border={[
                { side: "all", color: "yellow", size: "medium" },
                { side: "right", color: "brand", size: "medium" },
                { side: "top", color: "red", size: "medium" },
                { side: "left", color: "brand", size: "medium" },
              ]}
            />
            <Text size="small">Adding more seats for your event...</Text>
          </Box>
        </Layer>
      );
    }
    if (this.state.showAvailableSeatLoader) {
      chakracontent = (
        <Layer position="center">
          <Box
            align="center"
            direction="row"
            gap="small"
            pad="small"
            key="small"
          >
            <Spinner size="small" />
            <Text size="small">Loading Available TME Classroom Seats...</Text>
          </Box>
        </Layer>
      );
    }

    var HoustonCount = 0;
    var SgpCount = 0;
    var BristolCount = 0;

    var HoustonSeatLst = new Array();
    var BristolSeatLst = new Array();
    var SgpSeatLst = new Array();

    var HoustonSeatNames = new Array();
    var BristolSeatNames = new Array();
    var SgpSeatNames = new Array();

    var HoustonSelectedCount =
      this.state.houstonSelectedCount !== 0
        ? this.state.houstonSelectedCount
        : 0;
    var SgpSelectedCount =
      this.state.sgpSelectedCount !== 0 ? this.state.sgpSelectedCount : 0;
    var BristolSelectedCount =
      this.state.bristolSelectedCount !== 0
        ? this.state.bristolSelectedCount
        : 0;

    var TotalSelectedCount = 0;
    TotalSelectedCount =
      parseInt(this.state.selectedHouSeatNames.length) +
      parseInt(this.state.selectedBriSeatNames.length) +
      parseInt(this.state.selectedSgprSeatNames.length);

    if (this.state.eventTMECRSeats) {
      this.state.eventTMECRSeats.map((tmest) => {
        if (tmest.DataCenterName.toLowerCase().indexOf("houston") > 0) {
          HoustonCount = tmest.DCAvailableSeatCount;
          HoustonSeatLst = tmest.AvailableSeats;
        }
        if (tmest.DataCenterName.toLowerCase().indexOf("singapore") > 0) {
          SgpCount = tmest.DCAvailableSeatCount;
          SgpSeatLst = tmest.AvailableSeats;
        }
        if (tmest.DataCenterName.toLowerCase().indexOf("bristol") > 0) {
          BristolCount = tmest.DCAvailableSeatCount;
          BristolSeatLst = tmest.AvailableSeats;
        }
      });
    }

    HoustonSeatLst.map((hstSt) => {
      HoustonSeatNames.push(hstSt.TMESeat_Name);
    });

    BristolSeatLst.map((briSt) => {
      BristolSeatNames.push(briSt.TMESeat_Name);
    });

    SgpSeatLst.map((sgpSt) => {
      SgpSeatNames.push(sgpSt.TMESeat_Name);
    });

    var isSubmitdisabled = true;
    if (
      this.state.selectedHouSeatNames.length +
        this.state.selectedBriSeatNames.length +
        this.state.selectedSgprSeatNames.length >
      0
    ) {
      isSubmitdisabled = false;
    }

    console.log("Unparsed seats value - HOU ", this.state.selectedHouSeatNames);

    return (
      <Layer animate modal position="center">
        <Box align="center" justify="center">
          <Box
            align="center"
            justify="center"
            border={{ style: "solid" }}
            responsive
            overflow="auto"
            wrap={false}
            direction="column"
            pad="xsmall"
            gap="xsmall"
            alignSelf="center"
            elevation="small"
          >
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            />
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <Heading size="small" level="1" margin="small">
                  Add more seats for demo-event
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
              <Text size="large">
                {this.props.Event.Event_Title +
                  " - " +
                  this.props.Event.Event_ID}
              </Text>
            </Box>
            <Box
              align="stretch"
              justify="start"
              direction="column"
              pad="medium"
              gap="none"
              fill="horizontal"
            >
              <Box align="center" justify="between" direction="row">
                <Text>Selected seats for this classroom:</Text>
                <Box
                  align="center"
                  justify="center"
                  border={{ color: "brand", size: "medium" }}
                  round="full"
                  background={{ color: "brand" }}
                  elevation="small"
                  animation="pulse"
                >
                  <Text color="white">{TotalSelectedCount}</Text>
                </Box>
              </Box>
              {ghorChakracontent}
              {chakracontent}
              <Box
                align="center"
                justify="between"
                direction="row"
                pad="small"
                gap="large"
              >
                {HoustonSeatNames.length > 0 && (
                  <Text weight="bold">Houston</Text>
                )}
                {BristolSeatNames.length > 0 && (
                  <Text weight="bold">Bristol</Text>
                )}
                {SgpSeatNames.length > 0 && (
                  <Text weight="bold">Singapore</Text>
                )}
              </Box>
              <Box
                align="stretch"
                justify="between"
                direction="row"
                overflow="scroll"
              >
                {HoustonSeatNames.length > 0 && (
                  <CheckBoxGroup
                    value={this.state.selectedHouSeatNames}
                    onChange={(event) => {
                      this._handleHoustonSeatCount(event);
                      //console.log("value: ", event.value);
                      //console.log("option: ", event.option);
                      //setValue(event.value);
                    }}
                    options={HoustonSeatNames}
                  />
                )}
                {BristolSeatNames.length > 0 && (
                  <CheckBoxGroup
                    value={this.state.selectedBriSeatNames}
                    onChange={(event) => {
                      this._handleBristolSeatCount(event);
                      //console.log("value: ", event.value);
                      // console.log("option: ", event.option);
                      //setValue(event.value);
                    }}
                    options={BristolSeatNames}
                  />
                )}
                {SgpSeatNames.length > 0 && (
                  <CheckBoxGroup
                    value={this.state.selectedSgprSeatNames}
                    onChange={(event) => {
                      this._handleSgpSeatCount(event);
                      //console.log("value: ", event.value);
                      //console.log("option: ", event.option);
                      //setValue(event.value);
                    }}
                    options={SgpSeatNames}
                  />
                )}
              </Box>
            </Box>
            <Box align="center" justify="center">
              <Box
                align="center"
                justify="center"
                direction="row"
                gap="large"
                margin="medium"
              >
                <Button
                  label="Add Seats"
                  active={false}
                  primary
                  reverse
                  disabled={
                    tobeDisabled ||
                    isSubmitdisabled ||
                    this.state.AddSeatSubmitLoader
                  }
                  onClick={this._handleAddSeatsSubmit}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Layer>
    );
  }
}

export default TMEAddSeatsOverlay;
